import { ContentLayout } from 'layout/ContentLayout';

import WorkshopUpdateRequestOverviewCard from './WorkshopUpdateRequestOverviewCard';

const WorkshopUpdateRequestOverviewPage = () => {
  return (
    <ContentLayout>
      <WorkshopUpdateRequestOverviewCard />
    </ContentLayout>
  );
};

export default WorkshopUpdateRequestOverviewPage;
